import styled from "styled-components";

export const SContainer = styled.div`
  width: 100%;
  margin-top: 2rem;
`;

export const SLabelFormula = styled.label`
  margin-left: 0.2rem;
  margin-right: 0.5rem;
  font-size: 16pt;
`;

export const SInputFormula = styled.input`
  font-size: 16pt;
  margin-right: 0.5rem;
`;

export const SButtonCalculate = styled.button`
  font-size: 16pt;
  margin-left: 0.5rem;
`;

export const SPFormulaWeight = styled.p`
  margin-left: 3rem;
`;

export const SFormulaWeight = styled.span`
  margin-top: 2.5rem;
  margin-left: 1.5rem;
  width: 12rem;
  padding-left: 0.5rem;
  font-size: 16pt;
  border-bottom: 2px solid black;
  background-color: #ffffcc;
`;

export const STable = styled.table`
  border-collapse: collapse;
  border: 1px solid black;
  margin: 0.2rem 0.2rem;
`;

export const SCaption = styled.caption`
  margin-bottom: 0.5rem;
`;

export const SThead = styled.thead`
  text-align: center;
`;

export const STbody = styled.tbody`
  text-align: right;
`;

export const STh = styled.th`
  border: 1px solid black;
`;

export const STdC = styled.td`
  border: 1px solid black;
  text-align: center;
`;

export const STdR = styled.td`
  border: 1px solid black;
`;

export const SButtonCopyToClipboard = styled.button`
  margin: 0.5rem 0;
`;
